import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableMaterielCreatePage = withAsyncLoading(async () =>
    import('./MaterielCreatePage').then((res) => res.MaterielCreatePage)
);

export { LoadableMaterielCreatePage };
